import { Icon } from '../icon.tsx';
import type { IconProps } from '../icon.tsx';

export function IconCalendarEvent(props: IconProps) {
	return (
		<Icon stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" {...props}>
			<path d="M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -12" />
			<path d="M16 3l0 4" />
			<path d="M8 3l0 4" />
			<path d="M4 11l16 0" />
			<path d="M8 15h2v2h-2l0 -2" />
		</Icon>
	);
}
